'use strict';

const { pubdb } = Function('return this')();
const { make_datepicker, $ } = pubdb;


$(function () {
    make_datepicker('#due', 'datetimepicker');
});
